// 이용가이드 팝업
import React, { PropsWithChildren, useState, useLayoutEffect } from "react";
import styled from "styled-components";

import * as S from "../Styles/Style";

import { ReactComponent as Chevron } from "../Images/chevron.svg";
import guide_1 from "../Images/guide_1.webp";
import guide_2 from "../Images/guide_2.webp";
import guide_3 from "../Images/guide_3.webp";
import guide_4 from "../Images/guide_4.webp";

const PopupWrapper = styled.div`
	width: calc(100% - 2.8rem);
	max-height: 100vh;
	background-color: white;
	border-radius: 2rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;
const NextButton = styled(S.flexRowCenter)`
	position: absolute;
	top: 5vh;
	right: 1.4rem;
`;
const GuideImageArea = styled.div`
	height: 45vh;
	background-color: ${S.color.orange50};
	position: relative;
	& > div {
		width: 100%;
		padding: 0 1.2rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	button:first-child {
		transform: rotate(180deg);
	}
	button {
		width: 4.8rem;
		height: 4.8rem;
		background-color: white;
		border: 1px solid ${S.color.gray300};
		border-radius: 50%;
		position: relative;
		svg {
			width: 2.4rem;
			height: 2.4rem;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
	button:disabled {
		background-color: ${S.color.gray100};
		svg {
			fill: ${S.color.gray300};
		}
	}
`;
const ProgressBar = styled.div`
	height: 0.4rem;
	width: 100%;
	background-color: ${S.color.gray200};
	div {
		height: 100%;
		background-color: ${S.color.primary};
		transition: 0.3s;
	}
`;
const GuideTextArea = styled.div`
	padding: 0 2rem;
  height:8.8rem ;
  align-self: center;
  align-content:center;
`;

interface DefaultType {
	isOpen: boolean;
	close: () => void;
}

export default ({ isOpen, close }: PropsWithChildren<DefaultType>) => {
	const guideData = [
		{ text: "Silakan beli peti harta karun setelah login.", img: guide_1 },
		{ text: "Beli peti harta karun dan dapatkan hadiah.", img: guide_2 },
		{
			text: "Ajukan pengiriman atas harta karun yang kamu dapatkan melalui Harta Karun Saya.",
			img: guide_3,
		},
		{
			text: "Tukar harta karun yang kamu dapatkan menjadi poin.",
			img: guide_4,
		},
		// {
		// 	text: "Gabungkan harta karun yang kamu dapatkan untuk mendapatkan harta karun yang lebih baik.",
		// 	img: guide_5,
		// },
	];
	// 활성화 가이드 데이터
	const [selectedIndex, setSelectedIndex] = useState(0);
	// 이용가이드 확인 완료
	const postMessage = () => {
		if (typeof window == undefined || !window?.ReactNativeWebView) {
			return;
		} else {
			window.ReactNativeWebView?.postMessage(
				JSON.stringify({ type: "NOFIRSTGUIDE" })
			);
		}
	};
	const imgPreload = () => {
		guideData.map((item) => {
			let img = new Image();
			img.src = item.img;
		});
	};
	useLayoutEffect(() => {
		imgPreload();
	}, []);

	return (
		<S.popupContainer $isOpen={isOpen}>
			{selectedIndex == guideData.length - 1 && (
				<NextButton
					onClick={() => {
						postMessage();
						close();
					}}>
					<S.headline_3 color="white">Close</S.headline_3>
					{/* <Chevron fill="white" /> */}
				</NextButton>
			)}
			<PopupWrapper>
				<GuideImageArea>
					<S.heightImg src={guideData[selectedIndex].img} alt="" />
					<S.flexRowBetween>
						<button
							onClick={() => setSelectedIndex(selectedIndex - 1)}
							disabled={selectedIndex == 0}>
							<Chevron fill="black" />
						</button>
						<button
							onClick={() => setSelectedIndex(selectedIndex + 1)}
							disabled={selectedIndex == guideData.length - 1}>
							<Chevron fill="black" />
						</button>
					</S.flexRowBetween>
				</GuideImageArea>
				<ProgressBar>
					<div
						style={{
							width: `calc(100% / ${guideData.length} * ${selectedIndex + 1})`,
						}}></div>
				</ProgressBar>
				<GuideTextArea>
					<S.subhead_2>{guideData[selectedIndex].text}</S.subhead_2>
				</GuideTextArea>
			</PopupWrapper>
		</S.popupContainer>
	);
};
